import { render, staticRenderFns } from "./experts.vue?vue&type=template&id=60dabd19&scoped=true&"
import script from "./experts.vue?vue&type=script&lang=js&"
export * from "./experts.vue?vue&type=script&lang=js&"
import style0 from "./experts.vue?vue&type=style&index=0&id=60dabd19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dabd19",
  null
  
)

export default component.exports